import HttpClient from './http.client'

export default class ProviderService {
    static settings = (userId: number) =>
        HttpClient.get(`/users/${userId}/settings/`)

    static updateSettings = (userId: number, settings: any) =>
        HttpClient.put(`/users/${userId}/settings/`, { settings })
}
